// postService.js



// Function to fetch all blog posts with populated relations
export const fetchBlogPosts = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_STRAPI_API_BASE_URL}/api/blog-posts?populate[0]=Img&populate[1]=Category&populate[2]=Content.Image&populate[3]=MetaData.metaImage`);
        const data = await response.json();
        return data.data;
    } catch (error) {
        console.error("Error while fetching the blog posts: ", error);
    }
};

// Function to get the featured blog post
export const getFeaturedBlogPost = async () => {
    const blogs = await fetchBlogPosts();
    return blogs.find(blog => blog.Featured === true);
};

// Function to extract subheadings from blog content
export const getBlogContentWithSubHeadings = (blogContent) => {
    const subHeadings = [];
    blogContent.forEach(item => {
        if (item.Type === 'heading') {
            subHeadings.push({ id: item.HID, label: item.HTitle });
        }
    });
    return subHeadings;
};

// New function to fetch a single blog post by ID, including populated images and metadata
export const fetchBlogPost = async (id) => {
    try {
        
        const response = await fetch(`${process.env.REACT_APP_STRAPI_API_BASE_URL}/api/blog-posts/${id}?populate[0]=Img&populate[1]=Category&populate[2]=Content.Image&populate[3]=MetaData.metaImage`);
        const data = await response.json();

        if (!data.data) {
            throw new Error(`Blog post with id ${id} not found`);
        }
        return data.data;
    } catch (error) {
        console.error("Error while fetching the blog post:", error);
        throw error;
    }
};


export const fetchAllCategories=async()=>{
    try {
     const response=await fetch(`${process.env.REACT_APP_STRAPI_API_BASE_URL}/api/blog-categories`);
     let data=await response.json();
     
     return data.data;
     
    } catch (error) {
         console.log("Error which fetching the categories: ",error); 
    }
 }
 export const getCategoriesArray=(categories)=>{
   const Categories=[];
   categories.forEach(element => {
       Categories.push(element.Name)
   });
   return Categories;
   
   
 }
 export const fetchRelatedBlogs = async (id) => {
     try {
       const response = await fetch(`${process.env.REACT_APP_STRAPI_API_BASE_URL}/api/blog-posts?filters[documentId][$ne]=${id}&populate[1]=Category&populate[0]=Img`);
       const data = await response.json();
       return data.data;
     } catch (error) {
       console.error("Error fetching related blogs: ", error);
     }
   };

export const fetchAdComponent=async(slug)=>{
    try {
        const response=await fetch(`${process.env.REACT_APP_STRAPI_API_BASE_URL}/api/ad-components?filters[Slug][$eq]=${slug}&populate[0]=AdImage`);
        const data=await response.json();
        return data.data;
    } catch (error) {
        console.error("Error fetching the Ad Content: ",error);
    }

}